module.exports = __webpack_public_path__ + "img/Left_two.77e5af77.svg";